<template>
  <div class="custom-autocomplite">
    <div class="custom-label" :class="{'custom-valid-label': select}" v-if="placeholder" >
      {{ select ? placeholder : '' }}
    </div>
    <v-select
      v-model="select"
      :label="label"
      :placeholder="placeholder"
      :options="options"
      :disabled="disabled"
      :searchable="searchable"
      :inputHandler="inputHandler"
      :resetOnOptionsChange="true"
      :taggable="taggable"
      :clearable="clearable"
      :clickableParents="clickableParents"
      :ellipsisOption="ellipsisOption"
      :showAllControls="showAllControls"
      maxHeight="300px"
      :selectOnTab="selectOnTab"
      :setSearchOnBlur="setSearchOnBlur"
      :isInvalid="isInvalid"
      :createOption="createOption"
      @input="inputChangeHandler"
      @search="searchHandler"
      @search:blur="$emit('search:blur')"
      @onScroll="(e) => $emit('onScroll', e)"
    >
      <template slot="option" slot-scope="option" v-if="customOptions">
        <span>{{ option[label]}}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import VueSelect from './components/Select.vue'

export default {
  name: "BaseSelect",
  components: {
    vSelect: VueSelect
  },
  props: {
    isInvalid: {
      type: Boolean,
      default: false
    },
    setSearchOnBlur: {
      type: Boolean,
      default: false
    },
    selectOnTab: {
      type: Boolean,
      default: false
    },
    createOption: {
      type: Function,
      default(newOption) {
        if (typeof this.mutableOptions[0] === 'object') {
          newOption = {[this.label]: newOption}
        }
        this.$emit('option:created', newOption)
        return newOption
      }
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    taggable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Number, Object],
      default: null,
    },
    inputHandler: {
      type: Function,
      default: null,
    },
    selected: {
      type: Object,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: true
    },
    autocompleteAtOne: {
      type: Boolean,
      default: false
    },
    clickableParents: {
      type: Boolean,
      default: false
    },
    ellipsisOption: {
      type: Boolean,
      default: false
    },
    /**
     * Allow the custom options by slot.
     * @type {Boolean}
     */
    customOptions: {
      type: Boolean,
      default: false,
    },
    /**
     * If true then clear selected on Disabled = true
     * @type {Boolean}
     */
    clearSelectOnDisabled: {
      type: Boolean,
      default: true,
    },
    showAllControls: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      select: null,
    }
  },
  mounted() {
    if (this.selected) {
      this.select = this.selected
    }

    if (this.autocompleteAtOne && this.options.length === 1) {
      this.select = this.options[0]
    }
  },
  methods: {
    searchHandler(search, loading) {
      this.$emit('search', search, loading);
    },
    inputChangeHandler(newValue) {
      this.$emit('input', newValue);
    }
  },
  watch: {
    disabled(val) {
      if(val && this.clearSelectOnDisabled) {
        this.select = null;
      }
    },
    '$props.value': {
      handler(val) {
        const { select } = this;

        if (val && select && val.id === select.id) return;
        if (!val && !select) return;

        this.select = val;
      },
      immediate: true
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/md/_variables.scss";

.custom-label {
  color: $mdb-input-placeholder-color;
  font-size: .6875rem;
  height: 15px !important;
  line-height: 15px;
  text-align: left;
}
</style>
